import React, { forwardRef } from 'react';
import InputWithIconSC from '../atoms/InputWithIcon';
import TextInput from './TextInput';
import Icon from '~lib/frontend/design-system/components/Icon';
const IconTextInput = forwardRef(({ icon = 'ic_search', value, onChange, ...props }, ref) => (React.createElement(InputWithIconSC, null,
    React.createElement(TextInput, { value: value, onChange: e => onChange(e.target.value), ref: ref, ...props }),
    React.createElement(Icon, { icon: icon, "$size": '24px', "$color": 'primaryFill' }))));
export default IconTextInput;
